<!-- splash screen -->
<div #splashScreen id="splash-screen">
    <img alt="Logo" src="./assets/media/logos/logo.png" loading="lazy" decoding="async"/>
    <svg class="splash-spinner" viewBox="0 0 50 50">
        <circle
                class="path"
                cx="25"
                cy="25"
                fill="none"
                r="20"
                stroke="4c90bb"
                stroke-width="5"
        ></circle>
    </svg>
</div>
